export default {
  accountVerified: false,
  accountVerifiedMsg: '',
};
